export function AcmeLogo({ className }) {
  return (
    <div className={className}>
      <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" transform="translate(0.333374)" fill="#0720A8" />
        <path
          d="M24.0469 16.1719C24.5157 16.1293 25.0313 17.3438 25.5938 18.3281C26.8731 20.5669 27.0469 20.7656 28.1719 20.7656C29.25 20.7656 31.1719 18.9375 31.4063 19.1719C31.5938 19.3594 31.1253 19.6403 27.2344 23.5313C24.6563 26.1094 21.9337 28.7824 21.4219 29.25C18.7032 31.7344 14.7657 31.7344 14.7657 31.7344C14.7657 31.7344 14.3518 32.4332 19.2657 23.9531C23.4758 16.6875 23.5313 16.2188 24.0469 16.1719Z"
          fill="white"
        />
        <path
          d="M31.3594 23.0156C31.5938 23.2969 30.3282 24.1875 30.3282 25.5C30.3282 26.7188 30.5157 26.8594 31.9219 29.25C32.6454 30.4799 33.375 31.7344 33.375 31.7344C32.8125 31.7344 30.5625 31.8271 29.6719 31.4063C27.7757 30.5102 27.0081 28.2705 27.8792 26.4091C28.1147 25.9061 28.4301 25.5784 29.625 24.375C30.6563 23.2969 31.1762 22.7957 31.3594 23.0156Z"
          fill="white"
        />
        <path
          d="M38.7187 14.1399C38.7187 14.3062 38.5706 14.5222 38.2251 14.8595C37.9601 15.1182 37.7537 15.3265 37.7537 15.3265C37.7537 15.3265 37.8048 15.7744 37.868 16.148C38.0008 16.934 37.9994 16.9595 37.8142 17.1448C37.6241 17.335 37.6241 17.335 37.537 17.1118C37.3463 16.6227 37.0648 15.9697 37.0648 15.9697C37.0648 15.9697 36.0013 17.0351 33.8016 19.2315C31.1812 21.8482 27.7031 25.3594 27.7031 25.3594L27.2812 24.8906C27.2812 24.8906 30.8305 21.2984 33.3923 18.7271C35.6051 16.5061 36.6053 15.5102 36.6053 15.5102C36.6053 15.5102 36.1673 15.3172 35.9652 15.2359C35.2801 14.96 35.2345 14.9136 35.4632 14.7238C35.5814 14.6257 35.7574 14.6252 36.4333 14.7208C36.8337 14.7775 37.2945 14.8595 37.2945 14.8595C37.2945 14.8595 37.4989 14.6109 37.7537 14.37C38.3279 13.8269 38.7187 13.7337 38.7187 14.1399Z"
          fill="url(#paint0_linear_7486_2604)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_7486_2604"
            x1="36.0999"
            y1="16.4751"
            x2="29.9434"
            y2="22.6316"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

export default AcmeLogo;
